var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNtBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.553,
    height: 122.475,
    viewBox: "0 0 233.553 122.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -1007.272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.634,1004.312c31.665,2.9,60.535,11.258,78.051,29.89s18.723,47.885-6.448,66.039S172.8,1123.662,132.6,1122.154s-64.7-6.409-83.09-19.186c-39.562-27.483-35.282-73.794,15.569-89.905C104.142,1000.685,133.915,1001.41,165.634,1004.312Z",
    transform: "translate(-4.977 4.739)",
    fill: "#1e0073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.184,1080.241s-1.565,25.255,13.552,33.1c6.024,3.128,10.468,4.1,18.415,5.412s-2.431,6.731-19.14,6.216c-16.41-2.248-22.7-2.848-34.477-11.11-18.522-12.99-23.638-24.094-23.638-24.094Z",
    transform: "translate(-4.977 4.739)",
    fill: "#1e0073"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtBalloon);
export default __webpack_public_path__ + "static/media/nt-balloon.1e61b46dd7849aadc585b4d318e9646f.svg";
export { ForwardRef as ReactComponent };